import React from 'react';

import { ModalMultiDiscountComponent } from './ModalMultiDiscountComponent';
import { ModalConditionsComponent } from './ModalConditionsComponent';

import './ModalMetaDataComponent.scss';

export const ModalMetaDataComponent = ({
    i18n,
    REFUND,
    BRAND_NAME,
    partner,
    coupon,
    discounts
}) => (
    <section className="interstitiel-modal-metadata">
        <p className="bold">{i18n.CONDITIONS_TITLE}</p>
        <div className="grid-2 has-gutter">
            <ModalConditionsComponent
                partner={partner}
                coupon={coupon}
                i18n={i18n}
                BRAND_NAME={BRAND_NAME}
            />
            <ModalMultiDiscountComponent partner={partner} discounts={discounts} REFUND={REFUND} />
            <p>
                {i18n.CONDITIONS_CB_FLOA}
                <br></br>
                {i18n.CONDITIONS_CB_FLOA_2}
                <a href="https://moncashback.floabank.fr" target="_blank" rel="noopener noreferrer">
                    {i18n.CLICK_HERE}
                </a>
            </p>
        </div>
    </section>
);



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMetaDataComponent.js